<mat-table
  #datatable
  class="datatable__table"
  [dataSource]="dataSource"
  fusePerfectScrollbar
  matSort
  [matSortDisableClear]="true"
>
  <ng-container matColumnDef="number">
    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="20">
      {{ 'MAINTENANCES.HEADER.NUMBER' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let value" fxFlex="20" fxFlex.xs="100">
      <div class="relative">
        <span class="mobile-label">{{ 'MAINTENANCES.HEADER.NUMBER' | translate }}:</span>
        <div class="label" *ngIf="hasLabelViewPermission">
          <i
            *ngFor="let label of value.labels"
            [matTooltip]="label.name"
            [matTooltipShowDelay]="500"
            class="angularjs-fuse-icon icon-label {{ label.color }}-fg"
          >
          </i>
        </div>
        <span
          class="limit-cells"
          [matTooltip]="value.number + ' ' + ('MAINTENANCES.COPY_TO_CLIPBOARD' | translate)"
          [matTooltipShowDelay]="500"
        >
          <div class="label-color" [class.red-500-bg]="value.archived" [class.green-500-bg]="!value.archived"></div>
          <a class="copy-clipboard" (click)="copyToClipboard(value.number)">
            {{ value.number }}
          </a>
        </span>
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="location">
    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="40">
      {{ 'MAINTENANCES.HEADER.LOCATION' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let value" fxFlex="40" fxFlex.xs="100">
      <span class="mobile-label">{{ 'MAINTENANCES.HEADER.LOCATION' | translate }}:</span>
      <span class="limit-cells" [matTooltip]="value.location.name" [matTooltipShowDelay]="500">
        {{ value.location.name }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="type">
    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="10" fxHide.xs>
      {{ 'MAINTENANCES.HEADER.TYPE' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let value" fxFlex="10" fxHide.xs>
      <span class="mobile-label">{{ 'MAINTENANCES.HEADER.TYPE' | translate }}:</span>
      <span class="limit-cells" [matTooltip]="value.maintenanceType?.name" [matTooltipShowDelay]="500">
        {{ value.maintenanceType?.name }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="pendencies">
    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="40">
      {{ 'MAINTENANCES.HEADER.PENDENCIES' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let value" fxFlex="40" fxFlex.xs="100">
      <span class="mobile-label">{{ 'MAINTENANCES.HEADER.PENDENCIES' | translate }}:</span>
      <span class="limit-cells" *ngIf="!value.pendencies?.items?.length">-</span>
      <div class="flex flex-row limit-cells gap-2" *ngIf="value.pendencies?.items?.length">
        <palantir-tag
          [matTooltip]="value.pendencies.items[0].title"
          [matTooltipShowDelay]="500"
          [color]="'blue-grey'"
          [size]="'base'"
          [style]="'soft'"
          [shape]="'default'"
          class="first-pendency"
        >
          {{ value.pendencies.items[0].title }}
        </palantir-tag>

        <palantir-tag
          *ngIf="value.pendencies.items.length > 1"
          [color]="'blue'"
          [size]="'base'"
          [style]="'soft'"
          [shape]="'default'"
          [activatable]="true"
          [badge]="true"
          [matMenuTriggerFor]="appMenu"
          class="pendencies-count-badge"
        >
          +{{ value.pendencies.items.length - 1 }}
        </palantir-tag>
      </div>

      <mat-menu class="tag-list-dialog-menu" #appMenu="matMenu">
        <tag-list-dialog [title]="'MAINTENANCES.HEADER.PENDENCIES'" [tags]="getPendencyTitles(value.pendencies.items)">
        </tag-list-dialog>
      </mat-menu>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="segment">
    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="10">
      {{ 'MAINTENANCES.HEADER.SEGMENT' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let value" fxFlex="10" fxFlex.xs="100">
      <span class="mobile-label">{{ 'MAINTENANCES.HEADER.SEGMENT' | translate }}:</span>
      <span class="limit-cells" [matTooltip]="value.segment.name" [matTooltipShowDelay]="500">
        {{ value.segment.name }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="paymentNumber">
    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="10">
      {{ 'MAINTENANCES.HEADER.PAYMENT_NUMBER' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let value" fxFlex="10" fxFlex.xs="100">
      <span class="mobile-label">{{ 'MAINTENANCES.HEADER.PAYMENT_NUMBER' | translate }}:</span>
      <span class="limit-cells" [matTooltipShowDelay]="500" [matTooltip]="value.payment ? value.payment.number : '-'">
        <show-data-input
          *ngIf="value.payment"
          class="link"
          iconSize="small"
          suffix="open_in_new"
          (click)="redirectToPaymentsPage(value.payment.id)"
        >
          {{ value.payment.number }}
        </show-data-input>
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="paymentStatus">
    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="10">
      {{ 'MAINTENANCES.HEADER.PAYMENT_STATUS' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let value" fxFlex="10" fxFlex.xs="100">
      <span class="mobile-label">{{ 'MAINTENANCES.HEADER.PAYMENT_STATUS' | translate }}:</span>
      <span class="limit-cells" [ngClass]="(value.payment ? value.payment?.status : '') + '-fg'">
        {{ (value.payment ? value.payment?.status : '') | paymentStatus }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="message">
    <mat-header-cell *matHeaderCellDef fxFlex="40" fxHide.xs>
      {{ 'MAINTENANCES.HEADER.MESSAGE' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let value" fxFlex="40" fxHide.xs>
      <span class="mobile-label">{{ 'MAINTENANCES.HEADER.MESSAGE' | translate }}:</span>
      <span class="limit-cells" [matTooltip]="value.message" [matTooltipShowDelay]="500">
        {{ value.message }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="status">
    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="10">
      {{ 'MAINTENANCES.HEADER.STATUS' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let value" [ngClass]="value.status + '-fg'" fxFlex="10" fxFlex.xs="100">
      <div class="status-column">
        <span class="mobile-label">{{ 'MAINTENANCES.HEADER.STATUS' | translate }}:</span>
        {{ value.status | statusMaintenance }}
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="totalValue">
    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="10">
      {{ 'MAINTENANCES.HEADER.VALUE' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let value" fxFlex="10" fxFlex.xs="100">
      <div class="total-value-column">
        <span class="mobile-label">{{ 'MAINTENANCES.HEADER.VALUE' | translate }}:</span>
        R${{ value.totalValue | numberFormat }}
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="responseDeadlineStatus">
    <mat-header-cell *matHeaderCellDef fxFlex="8">
      {{ 'MAINTENANCES.HEADER.RESPONSE_DEADLINE' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let value" fxHide.xs fxFlex="8">
      <span class="mobile-label"> {{ 'MAINTENANCES.HEADER.RESPONSE_DEADLINE' | translate }}: </span>
      <div
        class="deadline-status-color"
        [ngClass]="'deadline-status-color--' + (value.responseDeadlineStatus | camelToKebabCase)"
      ></div>
      <span class="limit-cells">
        {{ value.responseDeadlineStatus | translateMaintenanceDeadlineStatus }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="solutionDeadlineStatus">
    <mat-header-cell *matHeaderCellDef fxFlex="8">
      {{ 'MAINTENANCES.HEADER.SOLUTION_DEADLINE' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let value" fxHide.xs fxFlex="8">
      <span class="mobile-label"> {{ 'MAINTENANCES.HEADER.SOLUTION_DEADLINE' | translate }}: </span>
      <div
        class="deadline-status-color"
        [ngClass]="'deadline-status-color--' + (value.solutionDeadlineStatus | camelToKebabCase)"
      ></div>
      <span class="limit-cells">
        {{ value.solutionDeadlineStatus | translateMaintenanceDeadlineStatus }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="company">
    <mat-header-cell *matHeaderCellDef mat-sort-header fxHide.xs fxFlex="8">
      {{ 'MAINTENANCES.HEADER.COMPANY' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let value" fxHide.xs fxFlex="8">
      <span class="mobile-label">{{ 'MAINTENANCES.HEADER.COMPANY' | translate }}:</span>
      <span
        class="limit-cells"
        [matTooltipShowDelay]="500"
        [matTooltip]="value.company?.name"
        [matTooltipDisabled]="!value.company?.name"
      >
        {{ value.company?.name || '-' }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="stars">
    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="10" fxHide.xs>
      {{ 'MAINTENANCES.HEADER.AVERAGE_RATINGS' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let value" fxFlex="10" fxHide.xs>
      <span class="mobile-label">{{ 'MAINTENANCES.HEADER.AVERAGE_RATINGS' | translate }}:</span>
      <span *ngIf="!value.ratingAverage" class="no-rating">-</span>
      <stars *ngIf="value.ratingAverage" class="rating-stars" [stars]="value.ratingAverage"></stars>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="openedAt">
    <mat-header-cell *matHeaderCellDef mat-sort-header fxHide.xs fxFlex="10">
      {{ 'MAINTENANCES.HEADER.OPENED_AT' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let value" fxHide.xs fxFlex="10">
      <span class="mobile-label">{{ 'MAINTENANCES.HEADER.OPENED_AT' | translate }}:</span>
      <span class="limit-cells" [matTooltip]="value.openedAt | date: 'dd/MM/yyyy HH:mm'" [matTooltipShowDelay]="500">
        {{ value.openedAt | date: 'dd/MM/yyyy HH:mm' }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="updatedAt">
    <mat-header-cell *matHeaderCellDef mat-sort-header fxHide.xs fxFlex="10">
      {{ 'MAINTENANCES.HEADER.UPDATED_AT' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let value" fxHide.xs fxFlex="10">
      <span class="mobile-label">{{ 'MAINTENANCES.HEADER.UPDATED_AT' | translate }}:</span>
      <span class="limit-cells" [matTooltip]="value.updatedAt | date: 'dd/MM/yyyy HH:mm'" [matTooltipShowDelay]="500">
        {{ value.updatedAt | date: 'dd/MM/yyyy HH:mm' }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="closedAt">
    <mat-header-cell *matHeaderCellDef mat-sort-header fxHide.xs fxFlex="10">
      {{ 'MAINTENANCES.HEADER.DONE_AT' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let value" fxHide.xs fxFlex="10">
      <span class="mobile-label">{{ 'MAINTENANCES.DONE_DATE' | translate }}:</span>
      <span
        class="limit-cells"
        *ngIf="value.closedAt"
        [matTooltip]="value.closedAt | date: 'dd/MM/yyyy HH:mm'"
        [matTooltipShowDelay]="500"
      >
        {{ value.closedAt | date: 'dd/MM/yyyy HH:mm' }}
      </span>
      <span *ngIf="!value.closedAt">-</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="scheduledAt">
    <mat-header-cell *matHeaderCellDef mat-sort-header fxHide.xs fxFlex="12">
      {{ 'MAINTENANCES.HEADER.SCHEDULED_AT' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let value" fxHide.xs fxFlex="12">
      <span class="mobile-label">{{ 'MAINTENANCES.HEADER.SCHEDULED_AT' | translate }}:</span>
      <span
        class="limit-cells"
        *ngIf="value.scheduled?.date"
        [matTooltip]="value.scheduled?.date | date: 'dd/MM/yyyy'"
        [matTooltipShowDelay]="500"
        [matTooltipDisabled]="!value.scheduled?.date"
      >
        {{ (value.scheduled?.date | date: 'dd/MM/yyyy') || '-' }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="scheduledTime">
    <mat-header-cell *matHeaderCellDef fxHide.xs fxFlex="10">
      {{ 'MAINTENANCES.HEADER.SCHEDULED_TIME' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let value" fxHide.xs fxFlex="10">
      <span class="mobile-label">{{ 'MAINTENANCES.HEADER.SCHEDULED_AT' | translate }}:</span>
      <span
        class="limit-cells"
        [matTooltip]="value.scheduled?.time"
        [matTooltipShowDelay]="500"
        [matTooltipDisabled]="!value.scheduled?.time"
      >
        {{ value.scheduled?.time || '-' }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="duration">
    <mat-header-cell *matHeaderCellDef fxHide.xs fxFlex="10">
      {{ 'MAINTENANCES.HEADER.DURATION' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let value" fxHide.xs fxFlex="10">
      <span class="mobile-label">{{ 'MAINTENANCES.HEADER.DURATION' | translate }}:</span>
      <span
        class="limit-cells"
        *ngIf="value.firstVisitStartedAt && value.closedAt"
        [matTooltipShowDelay]="500"
        [matTooltip]="value.firstVisitStartedAt | humanizeDuration: value.closedAt"
      >
        {{ value.firstVisitStartedAt | humanizeDuration: value.closedAt }}
      </span>
      <span *ngIf="!value.firstVisitStartedAt || !value.closedAt">-</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="visitCount">
    <mat-header-cell *matHeaderCellDef fxHide.xs fxFlex="8">
      {{ 'MAINTENANCES.HEADER.VISITS' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let value" fxHide.xs fxFlex="8">
      <span class="mobile-label">{{ 'MAINTENANCES.HEADER.VISITS' | translate }}:</span>
      <span
        [matTooltip]="value.visitCount | number"
        [matTooltipShowDelay]="500"
        [matTooltipDisabled]="!value.visitCount"
      >
        {{ (value.visitCount | number) || '-' }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="statusDescription">
    <mat-header-cell *matHeaderCellDef fxHide.xs fxFlex="8">
      {{ 'MAINTENANCES.HEADER.STATUS_DESCRIPTION' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let value" fxHide.xs fxFlex="8">
      <span class="mobile-label">{{ 'MAINTENANCES.HEADER.STATUS_DESCRIPTION' | translate }}:</span>
      <span
        [matTooltip]="value.statusDescription"
        [matTooltipShowDelay]="500"
        [matTooltipDisabled]="!value.statusDescription"
      >
        {{ value.statusDescription || '-' }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="warrantySummaryStatus">
    <mat-header-cell *matHeaderCellDef fxHide.xs fxFlex="8">
      {{ 'MAINTENANCES.HEADER.WARRANTY_SUMMARY_STATUS' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let value" fxHide.xs fxFlex="8">
      <span class="mobile-label">{{ 'MAINTENANCES.HEADER.WARRANTY_SUMMARY_STATUS' | translate }}:</span>
      <span
        *ngIf="value.warrantySummary?.status"
        [matTooltip]="value.warrantySummary?.status"
        [matTooltipShowDelay]="500"
        [matTooltipDisabled]="!value.warrantySummary?.status"
      >
        {{ 'MAINTENANCES.HEADER.WARRANTY.' + value.warrantySummary?.status?.toUpperCase() | translate }}
      </span>
      <span *ngIf="!value.warrantySummary?.status">
        {{ 'MAINTENANCES.HEADER.NO_WARRANTY_STATUS' | translate }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="linkedWarranties">
    <mat-header-cell *matHeaderCellDef fxHide.xs fxFlex="8">
      {{ 'MAINTENANCES.HEADER.LINKED_WARRANTIES' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let value" fxHide.xs fxFlex="8">
      <span class="mobile-label">{{ 'MAINTENANCES.HEADER.LINKED_WARRANTIES' | translate }}:</span>
      <span
        *ngIf="value.warrantySummary?.count?.total"
        [matTooltip]="value.warrantySummary?.count?.total"
        [matTooltipShowDelay]="500"
        [matTooltipDisabled]="!value.warrantySummary?.count?.total"
      >
        {{ value.warrantySummary?.count?.total }}
      </span>
      <span *ngIf="!value.warrantySummary?.count?.total">
        {{ 'MAINTENANCES.HEADER.NO_WARRANTY' | translate }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="warrantyStartDate">
    <mat-header-cell *matHeaderCellDef fxHide.xs fxFlex="8">
      {{ 'MAINTENANCES.HEADER.WARRANTY_START_DATE' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let value" fxHide.xs fxFlex="8">
      <span class="mobile-label">{{ 'MAINTENANCES.HEADER.WARRANTY_START_DATE' | translate }}:</span>
      <span
        *ngIf="value.warrantySummary?.startDate"
        [matTooltip]="value.warrantySummary?.startDate | date: 'dd/MM/yyyy'"
        [matTooltipShowDelay]="500"
        [matTooltipDisabled]="!value.warrantySummary?.startDate"
      >
        {{ value.warrantySummary?.startDate | date: 'dd/MM/yyyy' }}
      </span>
      <span *ngIf="!value.warrantySummary?.startDate">
        {{ 'MAINTENANCES.HEADER.EMPTY' | translate }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="warrantyEndDate">
    <mat-header-cell *matHeaderCellDef fxHide.xs fxFlex="8">
      {{ 'MAINTENANCES.HEADER.WARRANTY_END_DATE' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let value" fxHide.xs fxFlex="8">
      <span class="mobile-label">{{ 'MAINTENANCES.HEADER.WARRANTY_END_DATE' | translate }}:</span>
      <span
        *ngIf="value.warrantySummary?.extendedEndDate"
        [matTooltip]="value.warrantySummary?.extendedEndDate | date: 'dd/MM/yyyy'"
        [matTooltipShowDelay]="500"
        [matTooltipDisabled]="!value.warrantySummary?.extendedEndDate"
      >
        {{ value.warrantySummary?.extendedEndDate | date: 'dd/MM/yyyy' }}
      </span>
      <span *ngIf="!value.warrantySummary?.extendedEndDate">
        {{ 'MAINTENANCES.HEADER.EMPTY' | translate }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="weight">
    <mat-header-cell *matHeaderCellDef fxHide.xs fxFlex="5">
      {{ 'MAINTENANCES.HEADER.WEIGHT' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let value" fxHide.xs fxFlex="5">
      <span class="mobile-label">{{ 'MAINTENANCES.HEADER.WEIGHT' | translate }}:</span>
      <span> {{ value.weight }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="edit">
    <mat-header-cell *matHeaderCellDef fxFlex="7">
      {{ 'MAINTENANCES.HEADER.ACTIONS' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let maintenance" fxFlex="7" fxFlex.xs="100">
      <span class="uppercase bold m-auto" fxHide fxShow.xs>{{ 'MAINTENANCES.EDIT' | translate }}</span>
      <button
        data-cy="edit-maintenance-button"
        mat-icon-button
        [matTooltip]="(hasEditMaintenancePermission ? 'MAINTENANCES.EDIT' : 'MAINTENANCES.VIEW') | translate"
        (click)="editDialog(maintenance, !hasEditMaintenancePermission)"
      >
        <img src="assets/images/icons/new_icon_edit_action.svg" alt="edit maintenance" />
      </button>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="noData">
    <mat-footer-cell
      *matFooterCellDef
      [attr.colspan]="displayedColumns.length"
      fxLayout="column"
      fxLayoutAlign="center center"
    >
      {{ 'MAINTENANCES.NO_DATA' | translate }}
    </mat-footer-cell>
  </ng-container>

  <ng-container matColumnDef="loading">
    <mat-footer-cell
      *matFooterCellDef
      [attr.colspan]="displayedColumns.length"
      fxLayout="column"
      fxLayoutAlign="center center"
    >
      <div class="p-24" fxLayout="column" fxLayoutAlign="center center">
        <mat-spinner color="primary" diameter="64" class="mb-24"></mat-spinner>
        {{ 'MAINTENANCES.LOADING' | translate }}
      </div>
    </mat-footer-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  <mat-footer-row *matFooterRowDef="['noData']" [hidden]="isLoadingResults || dataSource?.length"></mat-footer-row>
  <mat-footer-row *matFooterRowDef="['loading']" [hidden]="!isLoadingResults || dataSource?.length"></mat-footer-row>
</mat-table>
<mat-paginator [length]="resultsLength" [pageSizeOptions]="[25, 50, 100, 200, 250]"></mat-paginator>
